import { isCanceledHttpRequest } from "@/browser";

interface IBackOffOptions {
  delay: number;
  factor: number;
  retries: number;
  shouldRetry: (error: any) => boolean;
}

const pause = (duration: number) => new Promise(res => setTimeout(res, duration));

export const backoff = <T>(fn: () => Promise<T>, options: IBackOffOptions): Promise<T> => {
  const { delay, factor, retries, shouldRetry } = options;

  return fn().catch(error => {
    if (isCanceledHttpRequest(error)) {
      return Promise.reject(error);
    }

    return retries > 1 && shouldRetry(error)
      ? pause(delay).then(() => backoff(fn, { ...options, retries: retries - 1, delay: delay * factor }))
      : Promise.reject(error);
  });
};
